module.exports = __webpack_public_path__ + "img/Hover_Online_Transaction.8d0648b7.png";